module.exports = __webpack_public_path__ + "img/galery-smart-scan-2-zoom.ce81f962.png";